export default __webpack_public_path__ + "static/video-698c8d77f472776f5827e78ba2094b9a.mp4";